module.exports = __webpack_public_path__ + "img/email.a15e59ad.svg";